module.exports = __webpack_public_path__ + "static/media/Teenage Dream.3fa74b8d.jpg";